<template>
  <div
    v-if="isMobileScreenSize"
    class="w-full flex border border-grey-300 rounded flex-col p-24"
  >
    <div class="flex justify-center">
      <TypographyBody class="font-bold w-full text-base"
        >{{ day }}s</TypographyBody
      >
      <Icon :iconClass="getIconClass()" @click="$emit('toggle')" />
    </div>
    <div
      v-if="isExpanded"
      class="flex flex-col justify-between w-full mt-16 -pb-16"
    >
      <div
        v-for="(time, index) in timeSlots"
        :key="time.value"
        :class="[
          'flex items-center py-16 border-t',
          index === timeSlots.length - 1 ? 'pb-0' : '',
        ]"
      >
        <input
          :id="`${day}-${time.value}`"
          v-model="selectedTimes"
          class="p-8"
          type="checkbox"
          :value="time.value"
        />
        <label
          :for="`${day}-${time.value}`"
          class="ml-4 font-semibold text-sm"
          >{{ time.label }}</label
        >
      </div>
    </div>
  </div>
  <div v-else class="w-full flex flex-col border border-grey-300 rounded p-24">
    <TypographyH2 class="font-bold w-full pb-16">{{ day }}s</TypographyH2>
    <div class="flex flex-col justify-between">
      <div
        v-for="(time, index) in timeSlots"
        :key="time.value"
        :class="[
          'flex items-center border-t p-16',
          index === timeSlots.length - 1 ? 'pb-0' : '',
        ]"
      >
        <input
          :id="`${day}-${time.value}`"
          v-model="selectedTimes"
          type="checkbox"
          :value="time.value"
        />
        <label
          :for="`${day}-${time.value}`"
          class="ml-4 font-semibold text-sm"
          >{{ time.label }}</label
        >
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '~/components/common/Icon.vue'
import TypographyH2 from '~/components/common/Typography/H2.vue'
import TypographyBody from '~/components/common/Typography/Body.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapGetters, mapActions } from 'vuex'
import {
  SCHEDULING_AVAILABILITY,
  SCHEDULING_AVAILABILITY_TIME_LABELS,
} from '@platform-shared/constants'

export default {
  components: { TypographyH2, TypographyBody, Icon },
  mixins: [screenSizeMixin],
  props: {
    day: {
      type: String,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('scheduling', ['getSelectedAvailabilityByDay']),
    selectedTimes: {
      get() {
        const dayAvailability = this.getSelectedAvailabilityByDay(this.day)
        return Object.entries(dayAvailability)
          .filter(([, isSelected]) => isSelected)
          .map(([time]) => time)
      },
      set(times) {
        const dayAvailability = this.getSelectedAvailabilityByDay(this.day)
        Object.keys(dayAvailability).forEach((time) => {
          this.selectAvailability({
            day: this.day,
            time,
            checked: times.includes(time),
          })
        })
      },
    },
    timeSlots() {
      return [
        {
          value: SCHEDULING_AVAILABILITY.TIMES.MORNING,
          label:
            SCHEDULING_AVAILABILITY_TIME_LABELS[
              SCHEDULING_AVAILABILITY.TIMES.MORNING
            ],
        },
        {
          value: SCHEDULING_AVAILABILITY.TIMES.MIDDAY,
          label:
            SCHEDULING_AVAILABILITY_TIME_LABELS[
              SCHEDULING_AVAILABILITY.TIMES.MIDDAY
            ],
        },
        {
          value: SCHEDULING_AVAILABILITY.TIMES.AFTERNOON,
          label:
            SCHEDULING_AVAILABILITY_TIME_LABELS[
              SCHEDULING_AVAILABILITY.TIMES.AFTERNOON
            ],
        },
      ]
    },
  },
  methods: {
    ...mapActions('scheduling', ['selectAvailability']),
    getIconClass() {
      return (
        'text-grey-500 cursor-pointer ' +
        (this.isExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down')
      )
    },
  },
}
</script>
